const RAW_SOCIAL_MEDIA_MAP = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  LINE: 'line',
  FACEBOOK: 'facebook',
  WECHAT: 'wechat',
  OTHERS: 'others',
} as const;

export const SOCIAL_MEDIA_MAP = new Proxy(RAW_SOCIAL_MEDIA_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 SOCIAL_MEDIA_MAP！请直接通过属性精准获取值，如 SOCIAL_MEDIA_MAP.INSTAGRAM',
    );
  },
});

export const SOCIAL_MEDIA_OPTION_LIST = [
  { value: SOCIAL_MEDIA_MAP.INSTAGRAM, label: 'Instagram' },
  { value: SOCIAL_MEDIA_MAP.WHATSAPP, label: 'WhatsApp' },
  { value: SOCIAL_MEDIA_MAP.LINE, label: 'LINE' },
  { value: SOCIAL_MEDIA_MAP.FACEBOOK, label: 'Facebook' },
  { value: SOCIAL_MEDIA_MAP.WECHAT, label: 'WeChat' },
  { value: SOCIAL_MEDIA_MAP.OTHERS, label: 'Others' },
];
